import Bootstrap from '$js/bootstrap';
import { HomepageHero } from '$src/js/modules/homepage-hero/homepage-hero';
import { TeamSlider } from '$src/js/modules/sliders/team-slider';
import { CopyToClipboard } from '$src/js/modules/copy-to-clipboard/copy-to-clipboard';
import { VisitStore } from '$src/js/modules/visit-store/visit-store';
import { ContentImageSlider } from '$src/js/modules/sliders/content-image-slider';
import { ContinueReading } from '$src/js/modules/continue-reading/continue-reading';
import { NavBar } from '$src/js/modules/nav-bar/nav-bar';
import initCookieConsent from '$src/js/modules/cookie-consent';
import { RelatedRemoveCurrentEntry } from '$js/modules/related-remove-current-entry/related-remove-current-entry';
import { ContentDateOfBirth } from '$js/modules/content/content-date-of-birth';
import { Newsletter } from '$src/js/modules/newsletter/newsletter';
import { Tabs } from '$src/js/modules/tabs/tabs';

// Prevent transitions on load
window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    document.body.classList.remove('no-transition');
  });
});

new Bootstrap();
new HomepageHero();
new TeamSlider();
new CopyToClipboard();
new VisitStore();
new ContentImageSlider();
new ContinueReading();
new NavBar();
new RelatedRemoveCurrentEntry();
new ContentDateOfBirth();
new Newsletter();
new Tabs();
initCookieConsent();
